import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';

var Avatar = function Avatar(_ref) {
  var _clsx;

  var alt = _ref.alt,
      src = _ref.src,
      title = _ref.title,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles;
  var classes = useStyles();
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _defineProperty(_clsx, classes[size], true), _clsx));
  return React.createElement("div", {
    className: containerStyle,
    style: inlineStyles
  }, React.createElement("img", {
    className: classes.image,
    alt: alt,
    src: src,
    title: title
  }));
};

export { Avatar };